$(function() {
	$('.form-register .list-radios input').on('change', function() {
		const $this = $(this);
		const $otherInput = $this.closest('.list-radios').next();

		if ($this.attr('id').indexOf('other') !== -1) {
			$otherInput.focus();
		} else {
			$otherInput.val('');
		}
	});

	$('.form-register .form__row--radios input[type="text"]').on('click keyup', function() {
		const $this = $(this);

		$this
			.prev()
			.find('input[id*="other"]')
			.trigger('click');
	});

	$('#field-email').on('keyup', function() {
		const $this = $(this);

		$('input[id*="id"]').val($this.val());
		$('.fields input[name="customer[email]"]').val($this.val());
	});

	$('#field-first-name, #field-last-name').on('keyup', function() {
		const $this = $(this);
		const name = $this.attr('name');
		const val = $this.val();

		$('.fields')
			.find('input[name="' + name + '"]')
			.val(val);
	});

	$('.form-register .form__row--password, .form-register .form__row--email').on('keyup', function() {
		const $this = $(this);
		const thisClass = '.' + $this.attr('class').replace(/\s/g, '.');

		checkElementsMatch(thisClass);
	});

	$('.form-register .form__row--password:first input').on('keyup', function() {
		const $this = $(this);

		$('.fields input[name="customer[password]"]').val($this.val());
	});

	// $('.form-register #field-country').on('change', function() {
	// 	$('.fields [name="customer[addresses][][country]"]').val($(this).val());

	// 	$('.fields [name="customer[addresses][][country]"').trigger('change');
	// });

	$('.form-register form .btn').on('click', function(e) {
		const $form = $(this).closest('form');

		if ($form.has('.form__row--error').length) {
			e.preventDefault();

			$('.form-register .form__errors p').html(
				$('.form__row--error')
					.first()
					.data('error')
			);
		}
	});
});

function checkElementsMatch(ele) {
	var firstVal = $(ele)
		.first()
		.find('input')
		.val();
	var secondVal = $(ele)
		.last()
		.find('input')
		.val();

	if (firstVal !== '' && secondVal !== '') {
		if (firstVal != secondVal) {
			$(ele).addClass('form__row--error');
		} else {
			$(ele).removeClass('form__row--error');

			$('.form__errors p').empty();
		}
	} else {
		$(ele).removeClass('form__row-error');
	}
}
